// Vendors
// Важно импортировать стили библиотеки вначале, чтобы они не затирали стили компонентов
import ViewUI, {locale as iLocale, Tooltip} from 'view-design';
import lang from 'view-design/dist/locale/ru-RU';
import 'view-design/dist/styles/iview.css';

import {isAjaxReady} from "@/1_webapi/helpers";
import Vue from 'vue'
import store from './store'
import router from "@/router";
import Root from "@/Root";

import {formatFinance, formatInteger, prettyJson} from "@/2_app-logic/utils/utils";
import {Api} from "@/1_webapi/api";

Vue.config.productionTip = false

// django gettext integration: https://gist.github.com/pierremonico/1190ab45da52ab59a3e403bd8c97772d
Vue.prototype.gettext = window.gettext


Vue.use(ViewUI);
iLocale(lang);

Vue.filter('integer', formatInteger)
Vue.filter('finance', formatFinance)
Vue.filter('prettyJson', prettyJson)

Vue.component('iTooltip', Tooltip);

export const api = new Api()

// Нужно дождаться загрузки файла general.js
isAjaxReady()
  .then(() => {
    new Vue({
      store,
      router,
      render: h => h(Root),
    }).$mount('#LocalPack_host')
  })